/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

export const PREFIX = 'CONSULT';

export const classes = {
  title: `${PREFIX}-title`,
  text: `${PREFIX}-text`,
  input: `${PREFIX}-input`,
};

export const StyledBox = styled(Box)(() => ({
  [`& .${classes.title}`]: {
    color: '#F1F1F1',
    fontSize: '32px',
    fontWeight: 300,
    lineHeight: '40px',
  },
  [`& .${classes.text}`]: {
    color: '#F1F1F1',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  [`& .${classes.input}`]: {
    maxWidth: '468px',
  },
}));
